import _ from "lodash";
import { QueryKey, useMutation, useQueryClient } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { brandingService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

const useTakeFromAgentMutation = (
	agentId: string,
	agentQueryKey?: QueryKey,
	mapOptimisticData?: (
		oldData: undefined | { [key: string]: any },
	) => undefined | { [key: string]: any },
) => {
	const dispatch = useDispatch();
	const queryClient = useQueryClient();

	return useMutation(
		() =>
			brandingService.takeSettingsFromAgent({
				agentId,
			}),
		{
			onSuccess() {
				if (
					agentQueryKey &&
					typeof mapOptimisticData === "function" &&
					!_.isEmpty(agentQueryKey)
				) {
					queryClient.setQueryData(agentQueryKey, mapOptimisticData);
				}
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useTakeFromAgentMutation;
